import { render, staticRenderFns } from "./FormularioContacto.vue?vue&type=template&id=3a0c40fe&scoped=true&"
import script from "./FormularioContacto.vue?vue&type=script&lang=ts&"
export * from "./FormularioContacto.vue?vue&type=script&lang=ts&"
import style0 from "./FormularioContacto.vue?vue&type=style&index=0&id=3a0c40fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a0c40fe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VForm,VRow,VSwitch,VTextField})
